import type { User } from "./types";

export const MODULE_ROUTES = [
  ["home", "/"],
  ["deals", "/deals"],
  ["charges", "/charges"],
  ["meter-readings", "/meter-readings"],
  ["orders", "/orders"],
  ["news", "/news"],
] as const;
export const requiredModule = (pathname: string) =>
  MODULE_ROUTES.find(([, path]) =>
    path === "/"
      ? pathname === "/"
      : pathname === path || pathname.startsWith(`${path}/`),
  )?.[0];
export const hasCabinetModule = (user: User | undefined, module: string) =>
  user?.renterCabinetAccess?.enabled === true &&
  user.renterCabinetAccess.modules.includes(module);
export const firstCabinetRoute = (user: User | undefined) =>
  MODULE_ROUTES.find(([module]) => hasCabinetModule(user, module))?.[1] ??
  "/profile";
